<template>

  <div>

    <service-form
      :is-new-service="true"
      :is-side-bar-active.sync="isAddNewServiceSidebarActive"
      @refetch-data="refetchData"
    />
    <service-form
      :is-new-service="false"
      :edit-service-data="editServiceData"
      :is-side-bar-active.sync="isEditServiceSidebarActive"
      @refetch-data="refetchData"
    />

    <!-- Table Container Card -->
    <b-card
      no-body
      class="mb-0"
    >
      <div class="m-2">

        <!-- Table Top -->
        <div
          v-if="$can('write', 'zones/services')"
          class="d-flex align-items-center justify-content-end"
        >
          <b-button
            variant="primary"
            @click="isAddNewServiceSidebarActive = true"
          >
            <span class="text-nowrap">Add Service</span>
          </b-button>
        </div>
      </div>
      <b-overlay
        variant="white"
        spinner-variant="primary"
        blur="0"
        opacity=".75"
        rounded="sm"
        :show="loadingServices"
      >
        <b-table
          ref="refServiceListTable"
          :per-page="perPage"
          :current-page="currentPage"
          class="position-relative"
          :items="services"
          responsive
          :fields="tableColumns"
          primary-key="id"
          show-empty
          empty-text="No matching drivers found"
        >

          <!-- Column: Service -->
          <template #cell(service)="data">
            <b-media vertical-align="center">
              <template #aside>
                <b-avatar
                  size="32"
                  :src="data.item.iconUrl"
                  :text="avatarText(data.item.service)"
                  variant="light-primary"
                />
              </template>
              <span
                class="font-weight-bold d-block text-nowrap"
              >
                {{ data.item.serviceLabel }}
              </span>
              <small class="text-muted">@{{ data.item.id }}</small>
            </b-media>
          </template>

          <!-- Column: Status -->
          <template #cell(status)="data">
            <b-badge
              pill
              :variant="`light-${resolveServiceStatusVariant(data.item.status)}`"
              class="text-capitalize"
            >
              {{ statusOptions[data.item.status].label }}
            </b-badge>
          </template>

          <!-- Column: Actions -->
          <template #cell(actions)="data">
            <b-dropdown
              variant="link"
              no-caret
              :right="$store.state.appConfig.isRTL"
            >

              <template #button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                  class="align-middle text-body"
                />
              </template>

              <b-dropdown-item
                v-if="$can('write', 'zones/services')"
                @click="displayEditSideBar(data.item)"
              >
                <feather-icon icon="EditIcon" />
                <span class="align-middle ml-50">Edit</span>
              </b-dropdown-item>
            </b-dropdown>
          </template>
        </b-table>
      </b-overlay>
      <div class="mx-2 mb-2">
        <b-row>

          <!-- Pagination -->
          <b-col
            cols="12"
            sm="12"
            class="d-flex align-items-center justify-content-between"
          >
            <b-form-group
              class="mb-0"
            >
              <label class="d-inline-block text-sm-left mr-50">Per page</label>
              <b-form-select
                id="perPageSelect"
                v-model="perPage"
                size="sm"
                :options="perPageOptions"
                class="w-50"
              />
            </b-form-group>
            <b-pagination
              v-model="currentPage"
              :total-rows="totalServices"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>

          </b-col>

        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BTable, BMedia, BAvatar, BOverlay, BButton, BBadge, BDropdown, BDropdownItem, VBModal, BPagination, BRow, BCol,
  BFormGroup, BFormSelect,
} from 'bootstrap-vue'
import { avatarText } from '@core/utils/filter'
import useServiceList from '@/views/services/useServiceList'
import ServiceForm from './ServicesForm.vue'

export default {
  components: {
    BFormGroup,
    BFormSelect,
    BRow,
    BCol,
    BPagination,
    BCard,
    BTable,
    BMedia,
    BAvatar,
    BOverlay,
    BButton,
    BBadge,
    BDropdown,
    BDropdownItem,

    ServiceForm,
  },
  directives: {
    'b-modal': VBModal,
  },
  setup() {
    const {
      fetchServices,
      tableColumns,
      refServiceListTable,
      loadingServices,
      isAddNewServiceSidebarActive,
      isEditServiceSidebarActive,
      displayEditSideBar,
      refetchData,
      statusOptions,
      editServiceData,

      resolveServiceStatusVariant,
      services,
      perPage,
      totalServices,
      currentPage,
      perPageOptions,

    } = useServiceList()

    return {
      services,
      fetchServices,
      tableColumns,
      refServiceListTable,
      loadingServices,
      isAddNewServiceSidebarActive,
      refetchData,
      statusOptions,
      editServiceData,
      isEditServiceSidebarActive,
      displayEditSideBar,
      perPage,
      totalServices,
      currentPage,
      perPageOptions,
      // UI
      resolveServiceStatusVariant,

      // Filter
      avatarText,
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
</style>
